import React from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

const ChartTwo = ({ data, title, sub_title }) => {
  ChartTwo.propTypes = {
    data: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
    sub_title: PropTypes.node.isRequired,
  };
  const darkColors = [
    "#1B2631",
    "#17202A",
    "#212F3D",
    "#283747",
    "#2E4053",
    "#34495E",
    "#3A4E6D",
    "#405475",
    "#4D6A88",
    "#566C93",
  ];

  const brightColors = [
    "#FF5733",
    "#FFBD33",
    "#FF33E9",
    "#33FF57",
    "#33A1FF",
    "#E933FF",
    "#33FFBD",
    "#5D33FF",
    "#33FFA1",
    "#FF3333",
  ];

  const combinedColors = darkColors.map((darkColor, index) => {
    return index % 2 === 0 ? brightColors[index] : darkColor;
  });

  const seriesData = data.map((item) => ({
    value: item.cargo_count,
    name: item.machine.name,
  }));

  const colors = seriesData.map((_, index) => combinedColors[index % combinedColors.length]);

  const getOption = () => {
    return {
      tooltip: {
        trigger: "item",
        textStyle: {
          fontFamily: "Vazir",
          fontSize: 11,
          fontWeight: "normal",
        },
      },
      legend: {
        show: false,
        orient: "vertical",
        left: "left",
        textStyle: {
          fontFamily: "Vazir",
          fontSize: 11,
          fontWeight: "normal",
        },
      },

      series: [
        {
          name: sub_title,
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: true,

            fontFamily: "Vazir",
            fontSize: 12,
            fontWeight: "bold",
          },

          data: seriesData,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2,
          },
        },
      ],
    };
  };

  return (
    <ReactECharts
      option={getOption()}
      style={{ height: 280, width: "100%", margin: 0, padding: 0 }}
    />
  );
};

export default ChartTwo;
